// Multi places
export const FUSION_PLACES_STATUS = {
  pending: 'pending',
  done: 'done'
}
